import { apiClient } from '../services/api';
import { trackCardReviewed } from './analytics';

export const logCardReview = async (cardId: number): Promise<void> => {
  try {
    const current = await apiClient.getCardReview(cardId);
    const newCount = (current?.review_count || 0) + 1;
    await apiClient.logCardReview(cardId, {
      last_reviewed_at: new Date().toISOString(),
      review_count: newCount,
    });
    trackCardReviewed(cardId);
  } catch {
    // non-blocking — review logging should never break the main flow
  }
};
